<template>
  <div>
    <b-card
      class="card-wrap"
      header="Faq details"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        id="my-table"
        :current-page="currentPage"
        :per-page="perPage"
        :items="faq"
        thead-class="header"
        class="mt-3"
        :fields="Columns"
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      perPage: 5,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      sortBy: "createdAt",
      sortDesc: true,
      taxcode: {},
      Columns: [
        {
          key: "Item Id",
          sortable: true,
        },
        {
          key: "Origin",
          sortable: true,
        },
        {
          key: "Manufacturing Date",
        },
        {
          key: "Expiry Date",
        },

        {
          key: "Quality",
        },
        {
          key: "Batch",
        },
        {
          key: "State",
        },
        {
          key: "Unique Id",
        },
      ],
    };
  },
};
</script>
<style scoped></style>
